import { defineField, defineType } from "sanity";

const flags: Record<string, string> = {
  sso_login_option_transcarent: "SSO Login option: Transcarent",
  rpm_show_progress_floating_indicator: "RPM: Show progress floating indicator",
  rpm_allow_show_tasks: "RPM: Allow show tasks",
  disable_request_callback_onboarding_call:
    "Disable Request Callback: Onboarding call",
  disable_scheduling_for_onboarding_initial_visit_rd:
    "Disable Scheduling for Onboarding Initial Visit RD",
  disable_scheduling_for_onboarding_initial_visit_pharmacist:
    "Disable Scheduling for Onboarding Initial Visit Pharmacist",
  disable_scheduling_for_onboarding_initial_visit_md:
    "Disable Scheduling for Onboarding Initial Visit MD",
  disable_pmp_loading_tracking: "Disable PMP Loading Tracking"
};

export const featureFlagItemType = defineType({
  type: "object",
  name: "featureFlagItem",
  title: "Feature Flag",
  fields: [
    defineField({
      name: "title",
      type: "string",
      title: "Key",
      validation: (Rule) => Rule.required(),
      options: {
        list: Object.keys(flags).map((f) => ({
          value: f,
          title: flags[f]
        }))
      }
    }),
    defineField({
      name: "value",
      type: "boolean",
      title: "Value",
      initialValue: false,
      validation: (Rule) => Rule.required()
    })
  ],
  preview: {
    select: {
      title: "title",
      value: "value"
    },
    prepare({ title, value }) {
      return {
        title: `${flags[title]}: ${value ? "ON" : "OFF"}`
      };
    }
  }
});
